import {facilityTypeColors} from "../../../constants/colors";

const getColor = (id: number) =>
    facilityTypeColors[id%facilityTypeColors.length];

export {getColor};